import React from "react";

export default function renderIcon({
  width = 22,
  height = 22,
  color = "#848484",
}) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11.5"
        cy="11.5"
        r="11"
        fill="black"
        fill-opacity="0.4"
        stroke="white"
      />
      <path
        d="M14.8341 11.1505L8.89405 6.03329C8.79492 5.94767 8.66311 5.8999 8.52603 5.8999C8.38895 5.8999 8.25714 5.94767 8.158 6.03329L8.153 6.03931C8.10467 6.08069 8.06618 6.13054 8.03987 6.18582C8.01357 6.2411 8 6.30065 8 6.36083C8 6.42102 8.01357 6.48057 8.03987 6.53585C8.06618 6.59113 8.10467 6.64098 8.153 6.68235L13.745 11.5014L8.153 16.3175C8.10467 16.3588 8.06618 16.4087 8.03987 16.464C8.01357 16.5192 8 16.5788 8 16.639C8 16.6992 8.01357 16.7587 8.03987 16.814C8.06618 16.8693 8.10467 16.9191 8.153 16.9605L8.158 16.9665C8.25714 17.0521 8.38895 17.0999 8.52603 17.0999C8.66311 17.0999 8.79492 17.0521 8.89405 16.9665L14.8341 11.8493C14.8865 11.8043 14.9283 11.7501 14.9568 11.69C14.9853 11.6299 15 11.5653 15 11.4999C15 11.4345 14.9853 11.3699 14.9568 11.3098C14.9283 11.2497 14.8865 11.1955 14.8341 11.1505Z"
        fill="white"
      />
    </svg>
  );
}
